import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

const mock = new MockAdapter(axios, { onNoMatch: 'passthrough', delayResponse: 1000 })

mock.onGet(RegExp(`isValidIban`)).reply(() => [200, Math.random() < 0.5])

// @TODO move this once we have api
interface IbanResponse {
  isValid: boolean
}

export default class IbanService {
  constructor(private apiGateway: string) {}
  validateIban(value: string): Promise<IbanResponse> {
    return axios
      .get(`${this.apiGateway}/isValidIban`, {
        params: {
          value,
        },
      })
      .then((res) => {
        return { isValid: true }
      })
  }
}
